module.exports = __webpack_public_path__ + "img/logo.a0b43569.png";